import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Helmet as Head } from 'react-helmet';
import styles from './style.module.css';
import IframeBack from '../iframe-back';

const meta = {
    'default': {
        title: 'Financial Calculators - Make The Right Decisions | Libro',
        description: 'When it comes to your personal finance, making and settling on decisions can be overwhelming. Use our financial calculators to help you make the right ones.'
    },
    'landing': {
        title: 'Financial Calculators | Libro Credit Union',
        description: 'Use our financial calculators to help you make the right decisions when it comes to your personal finance.'
    },
    'mortgage': {
        title: 'Financial Calculators - Mortgage Calculator  | Libro',
        description: 'Are you buying a new home? Our Mortgage Calculator makes it easier to search for your new home when you know what you can comfortably afford.'
    },
    'budget-planner': {
        title: 'Financial Calculators - Budget Planner | Libro',
        description: 'Insert your net income, expenses and savings and you\'ll get a clear picture of where you are financially. Create your monthly budget planner today.'
    },
    'prosperity-planner': {
        title: 'Financial Calculators - Prosperity Planner | Libro',
        description: 'Prosperity means different things to different people. Set your priorities, plan your steps, and enjoy the journey with our Prosperity Planner.'
    },
    'start-education-planning': {
        title: 'Financial Calculators - Start Education Planning | Libro',
        description: 'When it comes to your personal finance, making and settling on decisions can be daunting. Use our financial calculators to help you make the right ones.'
    },
    'resp-tax-benefits' :{
        title: 'Financial Calculators - RESP Tax Benefits | Libro',
        description: 'Want to see how much your investment will grow? Use this calculator to see the tax benefits of investing in a Registered Education Savings Plan'
    },
    'pay-debt-invest': {
        title: 'Financial Calculators - Pay Down Debt or Invest | Libro',
        description: 'When it comes to your personal finance, making and settling on decisions can be daunting. Use our financial calculators to help you make the right ones.'
    },
    'lif-payment':{
        title: 'Financial Calculators - LIF Payment | Libro ',
        description: 'When it comes to your personal finance, making and settling on decisions can be overwhelming. Use our financial calculators to help you make the right ones.'
    },
    'cpp-take-early':{
        title: 'Financial Calculators - CPP Benefits | Libro',
        description: 'When it comes to your personal finance, making and settling on decisions can be overwhelming. Use our financial calculators to help you make the right ones.'
    },
    'inflation-income':{
        title: 'Financial Calculators - Inflation & Retirement Income | Libro',
        description: 'When it comes to your personal finance, making and settling on decisions can be overwhelming. Use our financial calculators to help you make the right ones.'
    },
    'rrif-payment':{
        title: 'Financial Calculators - RRIF Payment | Libro Credit Union',
        description: 'When it comes to your personal finance, making and settling on decisions can be overwhelming. Use our financial calculators to help you make the right ones.'
    },
    'savings-goal':{
        title: 'Financial Calculators - Savings Goal | Libro Credit Union',
        description: 'When it comes to your personal finance, making and settling on decisions can be overwhelming. Use our financial calculators to help you make the right ones.'
    }
};

class MainPage extends Component {
    componentWillMount() {
        const {
            props: {
                history,
                navigationIndex
            }
        } = this;

        const redirectArray = navigationIndex
            .filter(({redirectFromSteps = false}) => redirectFromSteps === true)
            .reduce((total, {path}) => {
                total.push(path.replace(/^\/+/g, ''));
                return total;
            }, []);

        const pageURLSegments = this.getPageURLSegments();
        if (redirectArray.includes(pageURLSegments[1]) && pageURLSegments.length > 2) {
            history.push(`${process.env.PUBLIC_URL}/${pageURLSegments[1]}`);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            props: {
                location
            }
        } = this;

        if (location !== prevProps.location) {
            window.scrollTo(0, 0)
        }
    }

    getPageURLSegments() {
        const {
            props: {
                location
            }
        } = this;

        const pageURL = location.pathname.substring(process.env.PUBLIC_URL.length);
        return pageURL.split('/');
    }

    render() {
        const {
            props: {
                children
            }
        } = this;

        const pageURLSegments = this.getPageURLSegments();

        var className = styles.main;

        var notIframeForms = Array('budget-planner', 'mortgage', 'prosperity-planner');
        if (notIframeForms.includes(pageURLSegments[1]) == false) {
            className += ` ${styles.iframeForm}`;
        }

        // The landing page (no path segments beyond PUBLIC_URL) is the
        // calculators index itself, so a "Back to Calculators" link there is
        // redundant. Everywhere else it should always be available.
        const isLandingPage = pageURLSegments.filter(Boolean).length === 0;

        return (
            <div className={className}>
                <Head>
                    <meta key="og-image" property="og:image" content={`${window.location.origin}/images/libro-meta-image.png`}/>,
                    {
                        pageURLSegments.length > 1 && pageURLSegments[0] === '' && pageURLSegments[1] === '' && !meta[pageURLSegments[1]] && !meta[pageURLSegments[2]] &&
                        [
                            <title key='title'>{meta['landing'].title}</title>,
                            <meta key='og-title' property='og:title' content={meta['landing'].title}/>,
                            <meta key="description" property="description" content={meta['landing'].description}/>,
                            <meta key='og-description' property='og:description'
                                  content={meta['landing'].description}/>,
                        ]
                    }
                    {
                        pageURLSegments.length > 1 && meta[pageURLSegments[1]] === '' &&
                        [
                            <meta key='og-url' property='og:url' content={`${window.location.origin}${process.env.PUBLIC_URL}`}/>,
                            <link key='canonical' rel="canonical" href={`${window.location.origin}${process.env.PUBLIC_URL}`}/>
                        ]
                    }
                    {
                        pageURLSegments.length > 1 && meta[pageURLSegments[1]] !== '' &&
                        [
                            <meta key='og-url' property='og:url' content={`${window.location.origin}/${pageURLSegments[1]}`}/>,
                            <link key='canonical' rel="canonical" href={`${window.location.origin}/${pageURLSegments[1]}`}/>
                        ]
                    }
                    {
                        pageURLSegments.length > 2 &&
                        <meta name='robots' content='noindex'/>
                    }
                    {
                        pageURLSegments.length > 1 && meta[pageURLSegments[1]] &&
                        [
                            <title key='title'>{meta[pageURLSegments[1]].title}</title>,
                            <meta key='description' property='description'
                                  content={meta[pageURLSegments[1]].description}/>,
                            <meta key='og-title' property='og:title' content={meta[pageURLSegments[1]].title}/>,
                            <meta key='og-description' property='og:description'
                                  content={meta[pageURLSegments[1]].description}/>,

                        ]
                    }
                    {
                        pageURLSegments.length > 1 && pageURLSegments[1] !== '' && !meta[pageURLSegments[1]] && !meta[pageURLSegments[2]] &&
                        [
                            <title key='title'>{meta['default'].title}</title>,
                            <meta key='og-title' property='og:title' content={meta['default'].title}/>,
                            <meta key="description" property="description" content={meta['default'].description}/>,
                            <meta key='og-description' property='og:description'
                                  content={meta['default'].description}/>,
                        ]
                    }
                    {
                        pageURLSegments.length > 2 && pageURLSegments[2] && meta[pageURLSegments[2]] &&
                        [
                            <title key='title'>{meta[pageURLSegments[2]].title}</title>,
                            <meta key='description' property='description'
                                  content={meta[pageURLSegments[2]].description}/>,
                            <meta key='og-title' property='og:title' content={meta[pageURLSegments[2]].title}/>,
                            <meta key='og-description' property='og:description'
                                  content={meta[pageURLSegments[2]].description}/>,
                        ]
                    }
                </Head>
                <div className='print-only'>
                    <div className={styles.printHeader}>
                        <img
                            src={`${window.PUBLIC_URL}/images/logo-libro-blue.svg`}
                            alt='Libro Logo'
                        />
                    </div>
                </div>
                {/* Always-present way back to the calculators landing page
                    (rendered once here rather than per-calculator). */}
                {!isLandingPage && <IframeBack />}
                {children}
                <div className='print-only'>
                    <div className={styles.printFooter}>
                        <p>Call us: 1-800-361-8222</p>
                        <p>www.libro.ca</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(MainPage);
